var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    fill: "#23E377"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 21.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.4625V33.025C22 39.3625 25.5922 45.175 31.1074 47.8375C32.1234 48.325 33.2119 48.7 34.3004 48.9625L34.5181 49L34.6996 48.9625C35.7881 48.7 36.8766 48.325 37.8926 47.8375C43.4441 45.175 47 39.3625 47 33.025V23.4625L34.5181 19L22 23.4625ZM45.2946 33.025C45.2946 38.65 42.1016 43.825 37.1669 46.225C36.2961 46.6375 35.4253 46.975 34.5181 47.1625C33.611 46.9375 32.7039 46.6375 31.8694 46.225C26.9347 43.825 23.7417 38.65 23.7417 33.025V24.7375L34.5181 20.875L45.2946 24.7375V33.025Z",
    fill: "#12BF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2635 33.9785L29 35.2918L32.5676 39L40 31.3133L38.7365 30L32.5676 36.412L30.2635 33.9785Z",
    fill: "#12BF66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmCode);
export default __webpack_public_path__ + "static/media/confirmCode.b133a0ad00018887ed3ea633b5f41f33.svg";
export { ForwardRef as ReactComponent };